import React from 'react';

import { styled } from '@material-ui/core';
import { ThemeRes } from 'Web/Themes/ThemeRes';
import { StringKey } from 'Locales/fr';
import { Message } from 'Locales/I18nService';
import { StyledComponent } from '@material-ui/styles';

export const NunitoSansBlackTitle = styled('div')({
    fontFamily: ThemeRes.Fonts.fontFamilyNunitoSansBlack,
    fontWeight: 900,
    textTransform: 'uppercase',
    color: '#000000',
});

export const NunitoSansTitle = styled('div')({
    fontWeight: 400,
    fontFamily: ThemeRes.Fonts.fontFamilyNunitoSans,
    color: '#000000',
});

export const NunitoSansRegularTitle = styled('div')({
    fontWeight: 400,
    fontFamily: ThemeRes.Fonts.fontFamilyNunitoSansRegular,
    color: '#000000',
});

export const NunitoSansSemiBoldTitle = styled('div')({
    fontWeight: 600,
    fontFamily: ThemeRes.Fonts.fontFamilyNunitoSansSemiBold,
});

export const NunitoSansBoldTitle = styled('div')({
    fontWeight: 700,
    fontFamily: ThemeRes.Fonts.fontFamilyNunitoSansBold,
});

export const NunitoSansExtraBoldTitle = styled('div')({
    fontWeight: 800,
    fontFamily: ThemeRes.Fonts.fontFamilyNunitoSansExtraBold,
});

export const JostTitle = styled('div')({
    fontWeight: 400,
    fontFamily: ThemeRes.Fonts.fontFamilyJost,
    textTransform: 'uppercase',
    color: '#000000',
});

export const JostBoldTitle = styled('div')({
    fontWeight: 400,
    fontFamily: ThemeRes.Fonts.fontFamilyJostBold,
});

export const TextTitle = (Component: StyledComponent<any>, id: StringKey) => {
    return (
        <Component>
            <Message id={id} />
        </Component>
    );
};

export const TextContent = (Component: StyledComponent<any>, content: React.ReactNode) => {
    return <Component>{content}</Component>;
};

// type TextTitleProps ={Component:StyledComponent<any>| React.Component<any>}
// const TextTitle = ({Component}:TextTitleProps)=>{
//     return <Component>
//     </Component>
// }
